import { EXPIRED } from './EXPIRED.js';
import { INTERNAL_ERROR } from './INTERNAL_ERROR.js';
import { OUTPUT_DOWNSCALED } from './OUTPUT_DOWNSCALED.js';
import { OUTPUT_RESTRICTED } from './OUTPUT_RESTRICTED.js';
import { RELEASED } from './RELEASED.js';
import { STATUS_PENDING } from './STATUS_PENDING.js';
import { USABLE } from './USABLE.js';
/**
 * Media Key Statuses.
 *
 * @group DRM
 *
 * @beta
 */
export const MediaKeyStatus = {
    USABLE: USABLE,
    EXPIRED: EXPIRED,
    RELEASED: RELEASED,
    OUTPUT_RESTRICTED: OUTPUT_RESTRICTED,
    OUTPUT_DOWNSCALED: OUTPUT_DOWNSCALED,
    STATUS_PENDING: STATUS_PENDING,
    INTERNAL_ERROR: INTERNAL_ERROR,
};
//# sourceMappingURL=MediaKeyStatus.js.map